import React from 'react';
import { TIMELINE } from '../../../shared/Utils';
import { eventIcon } from './eventIcons';

interface LegendItem {
    label: string;
    color?: string;
    pattern?: boolean;
    icon?: string;
}

const ITEMS: LegendItem[] = [
    { label: 'Completed', color: TIMELINE.COMPLETEDCOLOR },
    { label: 'In Progress', color: TIMELINE.INPROGRESSCOLOR },
    { label: 'Scheduled', color: TIMELINE.SCHEDULEDCOLOR },
    { label: 'Slightly Late', color: TIMELINE.SLIGHTLYLATECOLOR },
    { label: 'Late (> 2 months)', color: TIMELINE.LATECOLOR },
    { label: 'Projected', pattern: true },
    { label: 'File Upload', icon: eventIcon('File') },
    { label: 'Comment', icon: eventIcon('Comment') },
    { label: 'Request', icon: eventIcon('Comment', 'Request') },
    { label: 'Revision Request', icon: eventIcon('Comment', 'RequestRevision') },
    { label: 'Response', icon: eventIcon('Comment', 'Response') },
    { label: 'Note', icon: eventIcon('Note') },
];

interface StatusLegendProps {
    // Labels to omit — e.g. the dashboard has no projected background or scheduled bars, and drops
    // the Request/Revision Request/Response event types, while still sharing this one legend with the
    // Progress Monitor (which keeps them all).
    exclude?: string[];
}

const StatusLegend: React.FC<StatusLegendProps> = ({ exclude }) => (
    <div style={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: '14px',
        padding: '8px 0',
        fontFamily: "'Segoe UI', sans-serif",
        fontSize: 12,
        color: 'rgb(118, 118, 118)',
    }}>
        {ITEMS.filter(item => !exclude?.includes(item.label)).map(item => (
            <div key={item.label} style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                {item.icon ? (
                    <i
                        className={item.icon}
                        style={{
                            fontSize: 18,
                            color: '#666666',
                            lineHeight: 1,
                        }}
                    />
                ) : item.pattern ? (
                    <span style={{
                        width: 14,
                        height: 14,
                        border: '1px solid rgba(120,120,120,0.4)',
                        background: 'repeating-linear-gradient(135deg, rgba(150,150,150,0.45) 0px, rgba(150,150,150,0.45) 3px, rgba(255,255,255,0.0) 3px, rgba(255,255,255,0.0) 6px)',
                    }} />
                ) : (
                    <span style={{
                        width: 14,
                        height: 14,
                        background: item.color,
                        border: '1px solid rgba(120,120,120,0.4)',
                    }} />
                )}
                <span>{item.label}</span>
            </div>
        ))}
    </div>
);

export default StatusLegend;
